/**
 * Determines if an office has child offices (is a parent office).
 * Note: The API includes the parent office itself in the childOffices array,
 * so we check for length > 1 to determine if there are actual child offices.
 *
 * @param childOffices - Array of child offices from the user state
 */
export const hasChildOffices = (childOffices?: unknown[] | null): boolean => {
  return Array.isArray(childOffices) && childOffices.length > 1;
};
